import { type ReactNode } from "react";
import { DEFAULT_LOCALE, getLocaleMeta, localizePath } from "@/lib/i18n-config";
import { translateText } from "@/lib/translation-memory";
import { I18nContext, type I18nValue } from "./I18nContext";

export default function I18nProvider({
  locale = DEFAULT_LOCALE,
  children,
}: {
  locale?: string;
  children: ReactNode;
}) {
  const value: I18nValue = {
    locale,
    meta: getLocaleMeta(locale),
    t: (text) => translateText(text, locale),
    localizeHref: (href) => localizePath(href, locale),
  };

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
